import {fetchAgeingData, fetchFileTypeData} from "../../../utils/dashboardCalls";

/**
 * Mock data retriever function. It mocks the retrieval of data for the TreeMap graph. Used for demonstration purposes.
 * @param {function} setRawData - Function to set the raw data state when the simulation of retrieval finishes.
 * @param {function} setLoading - Function to set the loading state when the simulation of retrieval starts and finishes.
 */
const mockDataRetriever = (setRawData, setLoading, _jobIds, _cid) => {
    const mockData = [
        {"company_id": 158, "date": "2022-04-21", "bytes": 0, "files": 1},
        {"company_id": 158, "date": "2022-05-24", "bytes": 0, "files": 4},
        {"company_id": 158, "date": "2022-06-16", "bytes": 222615, "files": 3},
        {"company_id": 158, "date": "2022-07-17", "bytes": 2226150, "files": 30},
        {"company_id": 158, "date": "2022-08-19", "bytes": 296820, "files": 4},
        {"company_id": 158, "date": "2022-09-20", "bytes": 1558305, "files": 21},
        {"company_id": 158, "date": "2022-10-21", "bytes": 2150415, "files": 29},
        {"company_id": 158, "date": "2022-11-23", "bytes": 4971735, "files": 67},
        {"company_id": 158, "date": "2022-12-26", "bytes": 1558560, "files": 21},
        {"company_id": 158, "date": "2022-11-28", "bytes": 296820, "files": 4},
        {"company_id": 158, "date": "2022-10-29", "bytes": 742050, "files": 10},
        {"company_id": 158, "date": "2022-09-30", "bytes": 296820, "files": 4},
        {"company_id": 158, "date": "2023-08-02", "bytes": 890460, "files": 12},
        {"company_id": 158, "date": "2023-07-04", "bytes": 519690, "files": 7},
        {"company_id": 158, "date": "2023-06-05", "bytes": 1187280, "files": 16},
        {"company_id": 158, "date": "2023-05-06", "bytes": 964665, "files": 13},
        {"company_id": 158, "date": "2023-04-09", "bytes": 890460, "files": 12},
        {"company_id": 158, "date": "2023-03-10", "bytes": 1633020, "files": 22},
        {"company_id": 158, "date": "2023-02-11", "bytes": 3042150, "files": 41},
        {"company_id": 158, "date": "2023-01-12", "bytes": 4080000, "files": 55},

        {"company_id": 158, "date": "2024-04-21", "bytes": 0, "files": 1},
        {"company_id": 158, "date": "2024-05-24", "bytes": 0, "files": 4},
        {"company_id": 158, "date": "2024-06-16", "bytes": 222615, "files": 3},
        {"company_id": 158, "date": "2024-07-17", "bytes": 2226150, "files": 30},
        {"company_id": 158, "date": "2024-08-19", "bytes": 296820, "files": 4},
        {"company_id": 158, "date": "2024-09-20", "bytes": 1558305, "files": 21},
        {"company_id": 158, "date": "2024-10-21", "bytes": 2150415, "files": 29},
        {"company_id": 158, "date": "2024-11-23", "bytes": 4971735, "files": 67},
        {"company_id": 158, "date": "2024-12-26", "bytes": 1558560, "files": 21},
        {"company_id": 158, "date": "2024-11-28", "bytes": 296820, "files": 4},
        {"company_id": 158, "date": "2024-10-29", "bytes": 742050, "files": 10},
        {"company_id": 158, "date": "2024-09-30", "bytes": 296820, "files": 4},
        {"company_id": 158, "date": "2024-08-02", "bytes": 890460, "files": 12},
        {"company_id": 158, "date": "2024-07-04", "bytes": 519690, "files": 7},
        {"company_id": 158, "date": "2025-06-05", "bytes": 1187280, "files": 16},
        {"company_id": 158, "date": "2025-05-06", "bytes": 964665, "files": 13},
        {"company_id": 158, "date": "2025-04-09", "bytes": 890460, "files": 12},
        {"company_id": 158, "date": "2025-03-10", "bytes": 1633020, "files": 22},
        {"company_id": 158, "date": "2025-02-11", "bytes": 3042150, "files": 41},
        {"company_id": 158, "date": "2025-01-12", "bytes": 4080000, "files": 55}
    ];

    const second = 1000;
    const mockDelay = 0.5 * second;
    setLoading(true);
    const handle = setTimeout(() => {
        setRawData(mockData);
        setLoading(false);
    }, mockDelay);
};
/**
 * Function to retrieve data for the age of files variant.
 * @param {function} setRawData - Function to set the raw data state when the retrieval finishes.
 * @param {function} setLoading - Function to set the loading state when the retrieval starts and finishes.
 */
const ageOfFilesDataRetriever = (setRawData, setLoading, jobIds, cid, options = {}) => {
    setLoading(true);
    fetchAgeingData(jobIds, cid, options)
        .then(data => {
            let resultsArray = [];
            let rawData = Object.values(data?.result ?? []);
            rawData.forEach(i => resultsArray.push(...i.data || []));
            setRawData(resultsArray);
            setLoading(false);
        })
        .catch(error => {
            if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') return;
            console.error("Error fetching age of files data in TreeMapGraph:", error);
            setRawData([]);
            setLoading(false);
        })
};
const filesTypeDataRetriever = (setRawData, setLoading, jobIds, cid, options = {}) => {
    setLoading(true);
    fetchFileTypeData(jobIds, cid, options)
        .then(resultsArray => {
            setRawData(resultsArray);
            setLoading(false);
        })
        .catch(error => {
            if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') return;
            console.error("Error fetching File Type data in TreeMapGraph:", error);
            setRawData([]);
            setLoading(false);
        })
};
/**
 * Map of data retriever functions for different variants.
 * @type {Object<string, function>}
 */
export const variantDataRetrieverMapTreeMapGraph = {
    defValue: mockDataRetriever,
    ageOfFilesData: ageOfFilesDataRetriever,
    filesTypeData: filesTypeDataRetriever
};